import { render, staticRenderFns } from "./justificationTypeFilterModal.vue?vue&type=template&id=28ed6fcb&"
import script from "./justificationTypeFilterModal.vue?vue&type=script&lang=js&"
export * from "./justificationTypeFilterModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports